import request from '@/api/config/request'

const prex = "api/solicitacao";

export function listSolicitacao(query = {}) {
    return request({
        url: `${prex}`,
        method: 'get',
        params: query
    })
}

export function getSolicitacao(tps_hash) {
    return request({
        url: `${prex}/${tps_hash}`,
        method: 'get'
    })
}

export function getHistorico(ceh_codigo) {
    return request({
        url: `${prex}/historico/${ceh_codigo}`,
        method: 'get'
    })
}

export function listSocios(tec_codigo) {
    return request({
        url: `${prex}/socio/${tec_codigo}`,
        method: 'get'
    })
}

export function setCecPessoaFisica(data) {
    return request({
        url: `${prex}/pessoa_fisica`,
        method: 'post',
        data
    })
}

export function setCecPessoaJuridica(data) {
    return request({
        url: `${prex}/pessoa_juridica`,
        method: 'post',
        data
    })
}

export function setCecContato(data) {
    return request({
        url: `${prex}/contato`,
        method: 'post',
        data
    })
}

export function setCecEndereco(data) {
    return request({
        url: `${prex}/endereco`,
        method: 'post',
        data
    })
}

export function setCecServico(data) {
    return request({
        url: `${prex}/servico`,
        method: 'post',
        data
    })
}

export function setCecCnaeServico(data) {
    return request({
        url: `${prex}/cnae_servico`,
        method: 'post',
        data
    })
}

export function setCecSetSocio(data) {
    return request({
        url: `${prex}/socio`,
        method: 'post',
        data
    })
}

export function deleteCecSetSocio(tms_codigo) {
    return request({
        url: `${prex}/socio/${tms_codigo}`,
        method: 'delete'
    })
}

export function setCecSetTabeliao(data) {
    return request({
        url: `${prex}/tabeliao`,
        method: 'post',
        data
    })
}

export function deleteCecSetTabeliao(tec_codigo) {
    return request({
        url: `${prex}/tabeliao/${tec_codigo}`,
        method: 'delete'
    })
}

export function setCecConfirmacao(data) {
    return request({
        url: `${prex}/confirmacao`,
        method: 'post',
        data
    })
}